import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminPermissions } from '@/hooks/admin/useAdminPermissions';

interface NonEngineerGuardProps {
    children: React.ReactNode;
}


export const NonEngineerGuard: React.FC<NonEngineerGuardProps> = ({ children }) => {
    const { permissions, loading } = useAdminPermissions();
    const location = useLocation();

    if (loading) return null;

    const isEngineerOnly = permissions.canViewAllData && !permissions.isAdmin;
    if (isEngineerOnly) {
        // Redirect engineers to site registration (upload) page
        return <Navigate to="/upload" replace state={{ from: location }} />;
    }

    return <>{children}</>;
};

export default NonEngineerGuard;
